import { createSelector } from 'reselect';

import {
    aggResultsIsLoadingSelector,
    flatAggregateResultsByVerifiedSenderSelector,
} from '../../common/selectors/aggregate-results-selectors';
import {
    domainsIsLoadingSelector
} from '../../common/selectors/domains-selectors';
import {
    actionsIsLoadingSelector
} from '../../common/selectors/actions-selectors';

function addCounts( accumulatedCounts, newCounts ){
    if( !accumulatedCounts ){
        return newCounts;
    }

    return {
        authorizedMailVolume: accumulatedCounts.authorizedMailVolume + newCounts.authorizedMailVolume ,
        blockedMailCount: accumulatedCounts.blockedMailCount + newCounts.blockedMailCount ,
        dkimAlignCount: accumulatedCounts.dkimAlignCount + newCounts.dkimAlignCount ,
        dkimFailCount: accumulatedCounts.dkimFailCount + newCounts.dkimFailCount ,
        dkimMisalignCount: accumulatedCounts.dkimMisalignCount + newCounts.dkimMisalignCount ,
        dkimNeutralCount: accumulatedCounts.dkimNeutralCount + newCounts.dkimNeutralCount ,
        dkimPassAlignCount: accumulatedCounts.dkimPassAlignCount + newCounts.dkimPassAlignCount ,
        dkimPassCount: accumulatedCounts.dkimPassCount + newCounts.dkimPassCount ,
        dkimTotalCount: accumulatedCounts.dkimTotalCount + newCounts.dkimTotalCount ,
        dmarcDoublePassCount: accumulatedCounts.dmarcDoublePassCount + newCounts.dmarcDoublePassCount ,
        dmarcFailCount: accumulatedCounts.dmarcFailCount + newCounts.dmarcFailCount ,
        dmarcPassCount: accumulatedCounts.dmarcPassCount + newCounts.dmarcPassCount ,
        ipCount: accumulatedCounts.ipCount + newCounts.ipCount ,
        spfAlignCount: accumulatedCounts.spfAlignCount + newCounts.spfAlignCount ,
        spfFailCount: accumulatedCounts.spfFailCount + newCounts.spfFailCount ,
        spfMisalignCount: accumulatedCounts.spfMisalignCount + newCounts.spfMisalignCount ,
        spfNeutralCount: accumulatedCounts.spfNeutralCount + newCounts.spfNeutralCount ,
        spfPassAlignCount: accumulatedCounts.spfPassAlignCount + newCounts.spfPassAlignCount ,
        spfPassCount: accumulatedCounts.spfPassCount + newCounts.spfPassCount ,
        spfTotalCount: accumulatedCounts.spfTotalCount + newCounts.spfTotalCount ,
        totalMailCount: accumulatedCounts.totalMailCount + newCounts.totalMailCount ,
        unauthorizedBlockedMailCount:
        accumulatedCounts.unauthorizedBlockedMailCount + newCounts.unauthorizedBlockedMailCount,
        unauthorizedDMARCPassCount: accumulatedCounts.unauthorizedDMARCPassCount + newCounts.unauthorizedDMARCPassCount,
        unauthorizedMailVolume: accumulatedCounts.unauthorizedMailVolume + newCounts.unauthorizedMailVolume ,
    };
}

export const mySendersAggSelector = createSelector(
    flatAggregateResultsByVerifiedSenderSelector,
    ( senderCounts ) => {
        const mySenderTableDataMap = senderCounts
            .reduce( ( accumulator, { name, senderId, ...counts } ) => {
                accumulator[name] = addCounts( accumulator[name], counts );
                accumulator[name].senderId = senderId;
                accumulator[name].name = name;

                return accumulator;
            }, {} );

        return Object.keys( mySenderTableDataMap ).map( ( key ) => mySenderTableDataMap[key] );
    }
);

export const mySendersDataIsLoadingSelector = createSelector(
    aggResultsIsLoadingSelector,
    domainsIsLoadingSelector,
    actionsIsLoadingSelector,
    ( aggResultsIsLoading, domainsIsLoading, actionsIsLoading ) => {
        return aggResultsIsLoading || domainsIsLoading || actionsIsLoading;
    }
);
